// extracted by mini-css-extract-plugin
module.exports = {"DataColumn":"Overall_DataColumn__2ziMF","LatestReviewsColumn":"Overall_LatestReviewsColumn__2MFo-","Row":"Overall_Row__2xQ5O"};